import React, { Component } from 'react';
import styles from './Chip.module.css';
import SvgAF from 'components/shared/SvgAF/SvgAF';
import classnames from 'classnames';
import { IconLoader } from 'common/IconLoader';

class Chip extends Component {
  state = { closeChip: false };

  handleClose = () => {
    this.setState({ closeChip: true });

    this.props.closeOn();
  };

  render() {
    const { title, value, noCloseIcon } = this.props;

    return (
      <div className={classnames(styles.chip, { [styles.hidden]: this.state.closeChip })}>
        <div className={styles.labelContainer}>
          <label className={styles.titleLabel}>{title}</label>
          <label className={styles.valueLabel}>{value}</label>
          {!noCloseIcon && (
            <button className={styles.closeButton} onClick={this.handleClose}>
              <SvgAF img={IconLoader.icon_clear_flter_x} hover={IconLoader.icon_clear_flter_x_hover} />
            </button>
          )}
        </div>
      </div>
    );
  }
}

export default Chip;
